<!-- 保密防护 -->
<template>
<div class='cm_list_page_container'>
  <div :class="mobileClass('cm_list_page_box')"><NewsList :data="ele" /></div>
</div>
</template>

<script>
import temp from "@/utils/importTemp.js";

export default {
//import引入的组件需要注入到对象中才能使用
components: temp,
data() {
//这里存放数据
return {
  ele:"",
  windowWidth:document.documentElement.clientWidth
};
},
//监听属性 类似于data概念
computed: {
  mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
},
//监控data中的数据变化
watch: {
  '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
},
//方法集合
methods: {
  loadItem(){
      let navList = this.$store.state.comData.navList
      for(let i=0;i<navList.length;i++){
        if(navList[i].path == this.$route.path){
          this.ele = navList[i]
        }
      }

    },
  initData(){

    if(this.$route.query.urlData == "" || this.$route.query.urlData ==undefined || this.$route.query.urlData == null){
      this.loadItem()
    }else{
      if(this.$route.query.urlData.data){
        this.ele = this.$route.query.urlData
      }else{
        this.ele = JSON.parse(this.$route.query.urlData);
      }
    }
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
},
beforeMount(){
this.initData()
}
//生命周期 - 挂载完成（可以访问DOM元素）
}
</script>
<style scoped>
.cm_list_page_container{
  width:100%;
  margin-top: 20px;
  display:flex;
  justify-content: center;
}
.cm_list_page_box{
  width:1200px;
}
.mobile_cm_list_page_box{
  width: 100%;
}
</style>
